<template>
  <div v-if="show" class="modal">
    <div class="modal__background" />

    <div class="modal__card">
      <header class="modal__header">
        <WarningSplashIcon />
      </header>
      <main class="modal__body">
        <slot />
      </main>
      <footer class="modal__footer">
        <Button class="btn btn--cancel" variant="primary" @click="$emit('cancel')">
          Отменить
        </Button>
        <Button class="btn btn--confirm" @click="$emit('confirm')"> Да, удалить </Button>
      </footer>
      <div class="modal__close" @click="$emit('cancel')">
        <CloseIcon />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/UiKit/v2/Button';
import WarningSplashIcon from '@/components/Icons/WarningSplashIcon';
import CloseIcon from '@/components/Icons/CloseIcon';

export default {
  name: 'DeleteModal',
  components: {
    Button,
    WarningSplashIcon,
    CloseIcon
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../style/utils/index';

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1000;

  &__background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(3px);
  }

  &__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 28px;
    z-index: 1;
    background: white;
    border-radius: 4px;
    width: 50ch;
  }

  &__header {
    margin-bottom: 16px;
  }

  &__body {
    @include uiFont;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    margin-bottom: 24px;
  }

  &__footer {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;

    .btn {
      height: 40px;
      flex: 1;
      width: 100%;
      min-width: 175px;

      &:first-child {
        margin-right: 8px;
      }

      @media screen and (max-width: 640px) {
        &:first-child {
          margin-right: 0;
          order: 2;
        }

        &:last-child {
          order: 1;
          margin-bottom: 8px;
        }
      }

      &:first-child:last-child {
        flex: 0;
        margin-right: 0;
        margin-bottom: 0;
      }
    }
  }

  &__close {
    position: absolute;
    z-index: 1;
    cursor: pointer;
    top: 0;
    right: -40px;

    @media screen and (max-width: 640px) {
      top: -40px;
      right: 4px;
    }
  }
}
</style>
